import { render, staticRenderFns } from "./ViewShared.vue?vue&type=template&id=856fccac&"
import script from "./ViewShared.vue?vue&type=script&lang=js&"
export * from "./ViewShared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports